var _a;
import api from "../../utils/api/api.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./rentRegistrationDocuments.constants";
export var getCount = (_a = generateApi(GENERATOR_PARAMS), _a.getCount), getPaged = _a.getPaged;
export var registrationAddDocuments = function (id, data) {
    return api.post("/rent-registrations/".concat(id, "/documents"), {
        data: data,
    });
};
export var registrationUpdateDocuments = function (_a) {
    var documentId = _a.documentId, registrationId = _a.registrationId, data = _a.data;
    return api.put("/rent-registrations/".concat(registrationId, "/documents/").concat(documentId), {
        data: data,
    });
};
export var registrationDeleteDocuments = function (documentId) {
    return api.delete("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(documentId));
};
